// import axios from "axios";
// import { keycloakInterceptor } from "../components/auth/keycloakService";
import { errorMessage } from "../messages/messages";
import type { IDocumentoArquivo } from "../components/Interfaces";
import { apiDocumentos } from "./api";

// const apiDocumentos = axios.create({
//     baseURL: import.meta.env.VITE_APP_URL_API_DOCUMENTOS,
// });

// apiDocumentos.interceptors.request.use(keycloakInterceptor);


export const getDocPdf = async (id: number) => {
    try {
        const { data } = await apiDocumentos.get<IDocumentoArquivo>(
            `/buscar/id/${id}`
        );

        window.open(`${import.meta.env.VITE_APP_URL_API_DOCUMENTOS}${data.path}`);
        
    } catch (error) {
        errorMessage("Não foi possível abrir o documento selecionado");
    }
};

export const urlDeUpload = `${import.meta.env.VITE_APP_URL_API_DOCUMENTOS}/upload`;
